module.exports = __webpack_public_path__ + "img/source06_01.8214a629.png";